import { Redirect, Route } from 'react-router-dom';
import { RouteProps, useHistory } from 'react-router';
import NotFound from './NotFound';
import { useMount } from '../hooks/useMount';
import { useState } from 'react';

interface RegexRedirectProps {
  from: string,
  to: string,
}

const buildUrl = (matches: RegExpMatchArray, url: string) => {
  matches.forEach((match, index) => {
    url = url.replace('$' + index, match);
  });

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('id')) {
    url += `?id=${urlParams.get('id')}`
  }
  return url;
}

const RegexRedirect: React.FunctionComponent<RegexRedirectProps & RouteProps> = (props) => {
  const history = useHistory();
  const [redirectPath, setRedirectPath] = useState<string|undefined>(undefined);

  useMount(() => {
    const path = history.location.pathname + history.location.search;
    const regex = new RegExp(props.from, 'i');

    const matches = path.match(regex);
    if (!matches) return;

    setRedirectPath(buildUrl(matches, props.to));
  });

  return !!redirectPath
    ? <Redirect to={redirectPath} />
    : <Route component={NotFound} />;
}

export default RegexRedirect;